/** True for individual product detail routes (not the catalog index). */
export function isProductDetailPage(pathname) {
	if (!pathname) return false;
	if (pathname === "/en/products" || pathname === "/es/productos") {
		return false;
	}
	return (
		pathname.startsWith("/en/products") ||
		pathname.startsWith("/es/productos")
	);
}
